<script setup>
  import {useId} from "vue";

  defineOptions({name: "ComponentIconAiSparkle"});

  defineProps({
    colored: {
      type: Boolean,
      default: true,
    },
  });

  // unique per instance so multiple icons on the same page don't share
  // (and clobber) each other's gradient definitions
  const uid = useId();
  const gradient1 = `icon-ai-sparkle-1-${uid}`;
  const gradient2 = `icon-ai-sparkle-2-${uid}`;
  const gradient3 = `icon-ai-sparkle-3-${uid}`;
</script>

<template>
  <svg width="18" height="23" viewBox="0 0 18 23" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path
      d="M14.1649 22.482C14.1532 22.5734 14.1062 22.6191 14.0241 22.6191C13.9538 22.6191 13.9069 22.5734 13.8834 22.482C13.6957 21.5529 13.341 20.7494 12.819 20.0716C12.2971 19.3938 11.6784 18.933 10.963 18.6893C10.8926 18.6589 10.8574 18.5979 10.8574 18.5066C10.8574 18.3999 10.8926 18.339 10.963 18.3238C11.6784 18.0801 12.2971 17.6193 12.819 16.9415C13.341 16.2637 13.6957 15.4603 13.8834 14.5311C13.9069 14.4397 13.9538 14.394 14.0241 14.394C14.0945 14.394 14.1414 14.4397 14.1649 14.5311C14.3525 15.4603 14.7073 16.2637 15.2293 16.9415C15.7512 17.6193 16.3699 18.0801 17.0853 18.3238C17.1557 18.339 17.1909 18.3999 17.1909 18.5066C17.1909 18.5979 17.1557 18.6589 17.0853 18.6893C16.3699 18.933 15.7512 19.3938 15.2293 20.0716C14.7073 20.7494 14.3525 21.5529 14.1649 22.482Z"
      :fill="colored ? `url(#${gradient1})` : 'currentColor'"
    />
    <path
      d="M14.1649 8.08794C14.1532 8.17933 14.1062 8.22503 14.0241 8.22503C13.9538 8.22503 13.9069 8.17933 13.8834 8.08794C13.6957 7.15882 13.341 6.35536 12.819 5.67755C12.2971 4.99975 11.6784 4.539 10.963 4.29529C10.8926 4.26483 10.8574 4.2039 10.8574 4.11251C10.8574 4.00589 10.8926 3.94497 10.963 3.92973C11.6784 3.68603 12.2971 3.22528 12.819 2.54747C13.341 1.86967 13.6957 1.06621 13.8834 0.137084C13.9069 0.0456947 13.9538 0 14.0241 0C14.0945 0 14.1414 0.0456947 14.1649 0.137084C14.3525 1.06621 14.7073 1.86967 15.2293 2.54747C15.7512 3.22528 16.3699 3.68603 17.0853 3.92973C17.1557 3.94497 17.1909 4.00589 17.1909 4.11251C17.1909 4.2039 17.1557 4.26483 17.0853 4.29529C16.3699 4.539 15.7512 4.99975 15.2293 5.67755C14.7073 6.35536 14.3525 7.15882 14.1649 8.08794Z"
      :fill="colored ? `url(#${gradient2})` : 'currentColor'"
    />
    <path
      d="M6.61493 19.2608C6.59147 19.4436 6.49764 19.535 6.33344 19.535C6.1927 19.535 6.09887 19.4436 6.05195 19.2608C5.67664 17.4026 4.96706 15.7957 3.92321 14.4401C2.87937 13.0845 1.642 12.163 0.211115 11.6755C0.0703717 11.6146 0 11.4928 0 11.31C0 11.0967 0.0703717 10.9749 0.211115 10.9444C1.642 10.457 2.87937 9.53551 3.92321 8.17991C4.96706 6.8243 5.67664 5.21738 6.05195 3.35913C6.09887 3.17635 6.1927 3.08496 6.33344 3.08496C6.47418 3.08496 6.56801 3.17635 6.61493 3.35913C6.99024 5.21738 7.69982 6.8243 8.74367 8.17991C9.78751 9.53551 11.0249 10.457 12.4558 10.9444C12.5965 10.9749 12.6669 11.0967 12.6669 11.31C12.6669 11.4928 12.5965 11.6146 12.4558 11.6755C11.0249 12.163 9.78751 13.0845 8.74367 14.4401C7.69982 15.7957 6.99024 17.4026 6.61493 19.2608Z"
      :fill="colored ? `url(#${gradient3})` : 'currentColor'"
    />
    <defs v-if="colored">
      <linearGradient :id="gradient1" x1="10.86" y1="14.39" x2="17.19" y2="22.62" gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFEDD4" />
        <stop offset="0.905" stop-color="#E10000" />
      </linearGradient>
      <linearGradient :id="gradient2" x1="10.86" y1="0" x2="17.19" y2="8.23" gradientUnits="userSpaceOnUse">
        <stop stop-color="#E10000" />
        <stop offset="1" stop-color="#E265F5" />
      </linearGradient>
      <linearGradient :id="gradient3" x1="0" y1="3.08" x2="12.67" y2="19.54" gradientUnits="userSpaceOnUse">
        <stop stop-color="#0085CC" />
        <stop offset="0.905" stop-color="#E265F5" />
      </linearGradient>
    </defs>
  </svg>
</template>
